import { render, staticRenderFns } from "./ListOnPic.vue?vue&type=template&id=4703a0ca&scoped=true&"
import script from "./ListOnPic.vue?vue&type=script&lang=ts&"
export * from "./ListOnPic.vue?vue&type=script&lang=ts&"
import style0 from "./ListOnPic.vue?vue&type=style&index=0&id=4703a0ca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4703a0ca",
  null
  
)

export default component.exports